<template>
  <div>
    <div class="md-layout-item md-size-100" v-if="!load">
      <md-progress-bar md-mode="indeterminate"></md-progress-bar>
    </div>
    <div v-if="load">
      <form novalidate class="md-layout" @submit.prevent="validateChain">
        <div class="md-layout-item md-size-100">
          <div class="md-title">Integration info</div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-85 md-small-size-100">
              <field fieldName="integrationApiKey" ref="integrationApiKey" :validations="{required: true}" :fieldValue=form.integrationApiKey
                fieldLabel="Integration API Key" fieldId="integrationApiKey" :sending="sending" @setfield="setFormField($event)"
                :disable='canGenerateApiKey === false' />
            </div>
            <div class="md-layout-item md-size-15 md-small-size-100" v-permission:isDeveloperOperator>
              <md-button class="md-raised md-primary" @click="generateApiKey">New API Key</md-button>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <field fieldName="authDomain" ref="authDomain" :fieldValue=form.authDomain fieldLabel="Auth domain"
                fieldId="authDomain" :sending="sending" @setfield="setFormField($event)" />
            </div>
            <div class="md-layout-item md-small-size-100">
              <field fieldName="oauthClientApplicationId" ref="oauthClientApplicationId" :fieldValue=form.oauthClientApplicationId
                fieldLabel="Oauth Client Application Id" fieldId="oauth-client-application-id" :sending="sending"
                @setfield="setFormField($event)" />
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <field-select fieldName="integratorId" ref="integratorId" :fieldValue="form.integratorId" fieldLabel="Integrators"
                fieldId="integrator" :values="integrators" valueId="id" valueLabel="name" :sending="sending" @setfield="setFormField($event)" />
            </div>
            <div class="md-layout-item md-small-size-100">
              <field fieldName="oauthClientScopes" ref="oauthClientScopes" :fieldValue=form.oauthClientScopes
                fieldLabel="Oauth client scopes" fieldId="oauth-client-scopes" :sending="sending" @setfield="setFormField($event)" />
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-checkbox v-model="form.enableIntegration">Enable Integration</md-checkbox>
            </div>
            <div class="md-layout-item md-small-size-100" v-if="createdOn">
              <label for="createdOn">Created On:</label>
              <div>{{createdOn}}</div>
            </div>
          </div>

          <label class="md-title">Available modules</label>

          <div class="md-layout">
            <div class="md-layout-item md-size-15 md-medium-size-35 md-small-size-50" v-for="(module, index) in modulesLayer" :key="index">
              <md-checkbox v-model="tempModules" :value="module">{{module.name}}</md-checkbox>
            </div>
          </div>

          <md-progress-bar md-mode="indeterminate" v-if="sending" />
          <div class="md-layout md-gutter" v-permission:isDeveloperOperator v-if="canGenerateApiKey">
            <div class="md-layout-item md-small-size-100">
              <md-button class="md-raised md-primary" :disabled="sending" @click="removeIntegration">Remove integration</md-button>
            </div>
            <div class="md-layout-item md-small-size-100 right-align">
              <md-button type="submit" class="md-raised md-primary" :disabled="sending">Save</md-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import Field from '@/components/elements/field'
import FieldSelect from '@/components/elements/select'
import Utils from '@/utils/utils'
import NotificationService from '@/services/notificationService'

export default {
  name: 'ChainIntegrationInfo',
  data: () => ({
    selectedChain: RepositoryService.session.selectedFacility,
    form: {
      integrationApiKey: null,
      trustedDomains: null,
      authDomain: null,
      integratorId: null,
      oauthClientApplicationId: null,
      oauthClientScopes: null,
      enableIntegration: false,
      modules: []
    },
    integrators: null,
    canGenerateApiKey: null,
    measurementSystems: null,
    countries: null,
    logoPreview: null,
    tempModules: [],
    modules: null,
    modulesLayer: null,
    sending: false,
    responseMessage: '',
    isChainApiKey: null,
    createdOn: null,
    load: false
  }),
  components: {
    Field,
    FieldSelect,
    NavigationLayout
  },
  props: ['parentref'],
  methods: {
    async validateChain () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (this.form.integratorId) {
        this.form.trustedDomains = this.integrators.find((element) => { return element.id === this.form.integratorId }).trustedDomains
      }
      if (this.tempModules && this.tempModules.length === 0) {
        canSave = false
      } else {
        this.form.modules = Utils.modulesLayerToModuleIds(this.tempModules)
      }
      if (canSave) {
        this.sending = true
        await NotificationService.manageNotification(this.parentref, await RepositoryService.saveIntegrationInfo(this.form),
          (data) => {
            this.parentref.$refs.navigationlayout.setNotification(`Integration saved with success`)
          })
        this.sending = false
      }
    },
    generateApiKey () {
      this.$refs['integrationApiKey'].form.integrationApiKey = Utils.generateGUID()
      this.form.integrationApiKey = this.$refs['integrationApiKey'].form.integrationApiKey
    },
    async removeIntegration () {
      this.sending = true
      await NotificationService.manageNotification(this.parentref, await RepositoryService.deleteIntegration(),
        (data) => {
          this.parentref.$refs.navigationlayout.setNotification(`Integration removed with success`)
          this.clearForm()
        })
      this.sending = false
    },
    clearForm () {
      this.tempModules = null
      this.form = {
        integrationApiKey: null,
        trustedDomains: null,
        authDomain: null,
        integratorId: null,
        oauthClientApplicationId: null,
        oauthClientScopes: null,
        enableIntegration: false,
        modules: []}
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].clearField) {
          this.$refs[property].clearField()
        }
      }
    },
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    },
    setFormArray (fieldObj) {
      if (this.form[fieldObj.fieldName] && this.form[fieldObj.fieldName].length === 1) {
        this.form[fieldObj.fieldName][0] = fieldObj.fieldValue
      } else {
        this.form[fieldObj.fieldName] = []
        this.form[fieldObj.fieldName].push(fieldObj.fieldValue)
      }
    }
  },
  created: async function () {
    await NotificationService.manageNotification(this.parentref, await RepositoryService.getIntegratorInfo(),
      (data) => {
        this.form.integrationApiKey = data.integrationApiKey
        this.form.trustedDomains = data.trustedDomains
        this.form.authDomain = data.authDomain
        this.form.oauthClientApplicationId = data.oauthClientApplicationId
        this.form.oauthClientScopes = data.oauthClientScopes
        this.form.enableIntegration = data.enableIntegration
        this.form.integratorId = data.integrator ? data.integrator.id : data.integrator
        this.canGenerateApiKey = data.canGenerateApiKey
        this.isChainApiKey = data.isChainApiKey
        if (data.createdOn) {
          this.createdOn = data.createdOn
        }
        this.modules = data.modules.sort(Utils.orderArrayObjectByFieldNumberAsc('id'))
      })
    for (var i = 0; i < this.modules.length; i++) {
      if (this.modules[i].isAvailable) {
        this.form.modules.push(this.modules[i].id)
      }
    }
    await NotificationService.manageNotification(this.parentref, await RepositoryService.getIntegrators(),
      (data) => {
        this.integrators = data.integrators.sort(Utils.orderArrayObjectByFieldNumberAsc('name'))
      })
    this.modulesLayer = Utils.modulesToModuleLayers(this.modules)

    this.tempModules = Utils.modulesLayerFromAvailableModules(this.modulesLayer)

    this.load = true
  }
}

</script>

<style lang="scss" scoped>
  .right-align {
    text-align: right;
  }

</style>
